import { AllergenDto } from './allergen.dto';
import { CartProductModifierGroupDto } from './cartProductModifierGroup.dto';
import { CustomerDto } from './customer.dto';
import { DiscountTypeDto } from './discountType.dto';
import { MerchantDto } from './merchant.dto';
import { OrderNoteOptionDto } from './orderNoteOption.dto';
import { PosDeviceDto } from './posDevice.dto';
import { ProductDto } from './product.dto';
import { ProductOutOfStockDto } from './productOutOfStock.dto';
import { SaleUnitCartSplitDto } from './saleUnitCartSplit.dto';
import { StockDto } from './stock.dto';

/**
 * Interface for the 'Cart' data
 */
export class CartProductDto {
  id: number;
  productId: number;
  menuId: number;
  name: string;
  photoURL: string;
  description: string;
  groups: CartProductModifierGroupDto[];
  quantity: number;
  subtotal: number;
  basePrice: number;
  merchant: MerchantDto;
  ingredients?: StockDto[];
  note?: string;
  clientSideId?: string;
  currencyCode: string;
  printName?: string;
  cartId?: number;
  guestId?: number;
  merchantId?: number;
  isPaid?: boolean;
  saleUnitCartSplitId?: number;
  saleUnitCartSplit?: SaleUnitCartSplitDto;
  isPrinted?: boolean;
  isVoid?: boolean;
  orderNoteOptions?: OrderNoteOptionDto[];
  customer?: CustomerDto;
  posDevice?: PosDeviceDto;
  posDeviceId?: number;
  isDiscountable?: boolean;
  sequence?: number;
  managerEmployeeId?: number;
  operatorEmployeeId?: number;
  isMoved: boolean;
  isMovedOnTable?: boolean;
  bundleProductChecked?: boolean;
  isBundle?: boolean;
  bundleCombinationId?: string;
  bundleIdentifier?: number;
  checkedToUse?: boolean;
  checkedToUseOnTable?: boolean;
  isCoveredByLoyaltyPoints?: boolean;
  quantityCoveredByLoyalty?: number;
  isOpenPrice: boolean;
  openPrice?: number;
  createdDate: Date;
  discountAmount?: number;
  discountTypeId?: number;
  cartProductDiscountType?: DiscountTypeDto;
  hasProductDiscount: boolean;
  isStaffFood?: boolean;
  allergens?: AllergenDto[];
  clickedSequence?: number;
  splitCartProductId?: number;
  tableSeat?: string;
  isUpsell?: boolean;
  isPartOfBundle?: boolean;
  product?: ProductDto;
  productsOutOfStock?: ProductOutOfStockDto[];
  stockSelected?: number;
  isAgeVerification: boolean;
  drsValue?: number;
}
